/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: qtWvXH8Uhh67sc1TY2MZeK

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsd5V9Y7YjWcfm } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: D5V9y7YjWCFM/globalVariant
import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: ROqE-xVeeGeS/globalVariant
import { Theme2Value, useTheme2 } from "./PlasmicGlobalVariant__Theme2"; // plasmic-import: qx8n7Mp9hEdp/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsd5V9Y7YjWcfm,
  theme: useTheme,
  theme2: useTheme2
});
